<div class="wrapper">

    <div class="row">

        <div class="col-sm-12 mb-2">
            <h1 class="pageTitle">{{pageTitle}}</h1>
            <app-notifications [notification]="'booking_details_page_notification_banner_child'"></app-notifications>
            <hr>
        </div>

        <div class="col-sm-12 col-md-7 col-lg-8 mt-4">

            <div class="card bb-panel">
                <form [formGroup]="customerDetailsForm" class="col-sm-12">
                    <h4 class="mt-1 pb-4">Personal information</h4>
                    <div>
                        <div class="form-group">
                            <label for="first_name"> <span aria-hidden="true" class="form-field-required-marker">
                                    *</span> {{'COMMON.FIRST_NAME' | translate}}</label>
                            <input type="text" class="form-control" formControlName="first_name" role="textbox"
                                id="first_name">
                            <div *ngIf="submitted && form.first_name.errors" class="invalid-feedback">
                                <div *ngIf="form.first_name.errors.required" role="alert" tabindex="0">
                                    First name is required</div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="last_name"> <span aria-hidden="true" class="form-field-required-marker">
                                    *</span> {{'COMMON.LAST_NAME' | translate}}</label>
                            <input type="text" class="form-control" formControlName="last_name" role="textbox"
                                id="last_name">
                            <div *ngIf="submitted && form.last_name.errors" class="invalid-feedback">
                                <div *ngIf="form.last_name.errors.required" role="alert" tabindex="0">
                                    Last name is required</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="email_address"> <span aria-hidden="true" class="form-field-required-marker">
                                    *</span> {{'COMMON.EMAIL_ADDRESS' | translate}}</label>
                            <input type="email" class="form-control" formControlName="email_address" role="textbox"
                                (change)="checkIfDupeUser()" (keydown.space)="$event.preventDefault();"
                                (input)="removeSpaces('email_address')" (keydown.spacebar)="$event.preventDefault();"
                                id="email_address">
                            <div *ngIf="submitted && form.email_address.errors" class="invalid-feedback">
                                <div *ngIf="form.email_address.errors.pattern" role="alert" tabindex="0">
                                    {{'COMMON.VALID_EMAIL' | translate}}</div>
                                <div *ngIf="form.email_address.errors.required" role="alert" tabindex="0">
                                    Email address is required</div>
                            </div>
                        </div>

                        <!-- Confirm email address -->
                        <div *ngFor="let question of customerQuestions">
                            <div class="form-group"
                                *ngIf="question.visible && question.detail_type == 'text_field' && question.reference.toString() === this.emailValidationId">
                                <label for="{{question.name}}"><span *ngIf="question.required" aria-hidden="true"
                                        class="form-field-required-marker">
                                        *</span> {{question.name}}</label>

                                <input type="text" class="form-control" formControlName="{{question.reference}}"
                                    role="textbox" attr.aria-label="{{question.name}} input field"
                                    (input)="removeSpaces(emailValidationId)"
                                    (keydown.space)="$event.preventDefault();" id="{{question.name}}"
                                    (keydown.spacebar)="$event.preventDefault();">
                                <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                                    <div *ngIf="form[question.reference].errors.mismatch" role="alert">
                                        {{'COMMON.EMAIL_MISMATCH' | translate}}</div>
                                    <div *ngIf="form[question.reference].errors.required" role="alert">{{question.name}}
                                        is
                                        required</div>
                                </div>
                            </div>
                        </div>



                        <!-- Customer questions -->
                        <div *ngFor="let question of customerQuestions;">

                            <div *ngIf="question.reference.toString() != this.emailValidationId && question.id != 382">

                                <div [ngClass]="{'margin-bottom': question.help_text, 'form-group' : true}"
                                    *ngIf="question.visible && question.detail_type == 'text_field'">
                                    <label><span *ngIf="question.required" aria-hidden="true"
                                            class="form-field-required-marker">
                                            *</span> {{question.name}}</label>

                                    <input type="text" class="form-control" formControlName="{{question.reference}}"
                                        role="textbox" attr.aria-label="{{question.name}} input field"
                                        *ngIf="question.reference !== 39 && question.reference !== 363">


                                    <input type="text" class="form-control" formControlName="{{question.reference}}"
                                        role="textbox" attr.aria-label="{{question.name}} input field"
                                        *ngIf="question.reference == 363" maxlength="11"
                                        (keypress)="keyPressNumberField($event)">


                                    <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                                        <div *ngIf="form[question.reference].errors.required" role="alert">
                                            {{question.name}}
                                            is
                                            required</div>
                                        <div *ngIf="form[question.reference].errors.pattern" role="alert">
                                            invlaid {{question.name}}</div>
                                        <div *ngIf="form[question.reference].errors.mismatch">{{'COMMON.EMAIL_MISMATCH'
                                            | translate}}</div>
                                    </div>
                                </div>

                                <div class="form-group" *ngIf="question.visible && question.detail_type == 'text_area'">
                                    <label><span *ngIf="question.required" aria-hidden="true"
                                            class="form-field-required-marker">
                                            *</span> {{question.name}}</label>
                                    <textarea (change)="this.formatPostcode()" class="form-control"
                                        formControlName="{{question.reference}}"
                                        attr.aria-label="{{question.name}} text area field"></textarea>
                                    <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                                        <div *ngIf="form[question.reference].errors.required" role="alert">
                                            {{question.name}}
                                            is
                                            required</div>
                                        <div *ngIf="form[question.reference].errors.pattern" role="alert">
                                            invlaid {{question.name}}</div>
                                    </div>
                                </div>

                                <div class="form-group" *ngIf="question.visible && question.detail_type == 'number'">
                                    <label><span *ngIf="question.required" aria-hidden="true"
                                            class="form-field-required-marker">
                                            *</span> {{question.name}}</label>
                                    <input type="search" class="form-control" formControlName="{{question.reference}}"
                                        attr.aria-label="{{question.name}} input field"
                                        (keypress)="keyPressNumberField($event)" maxlength="11">
                                    <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                                        <div *ngIf="form[question.reference].errors.required" role="alert">
                                            {{question.name}}
                                            is
                                            required</div>
                                        <div *ngIf="form[question.reference].errors.pattern" role="alert">
                                            invlaid {{question.name}}</div>
                                    </div>
                                </div>

                                <div class="form-group"
                                    *ngIf="question.visible && question.detail_type == 'select' || question.visible && question.detail_type == 'select-price'">
                                    <label><span *ngIf="question.required" aria-hidden="true"
                                            class="form-field-required-marker">
                                            *</span> {{question.name}}</label>
                                    <select formControlName="{{question.reference}}" [value]='-1' class="form-control"
                                        (change)="onQuestionChange()" attr.aria-label="{{question.name}}">

                                        <option></option>
                                        <option *ngFor="let option of question.options" [value]="option.name">
                                            {{option.name}}
                                        </option>

                                    </select>
                                    <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                                        <div *ngIf="form[question.reference].errors.required" role="alert">
                                            {{question.name}}
                                            is
                                            required</div>
                                        <div *ngIf="form[question.reference].errors.pattern" role="alert">
                                            invlaid {{question.name}}</div>
                                    </div>
                                </div>

                                <div class="form-group" *ngIf="question.visible && question.detail_type == 'date'">
                                    <label><span *ngIf="question.required" aria-hidden="true"
                                            class="form-field-required-marker">
                                            *</span> {{question.name}}</label>
                                    <input matInput formControlName="{{question.reference}}" [matDatepicker]="picker"
                                        readonly>
                                    <mat-datepicker-toggle matSuffix [for]="picker">
                                    </mat-datepicker-toggle>
                                    <mat-datepicker #picker>
                                    </mat-datepicker>
                                    <span *ngIf="question.help_text" class="help-text mb-3 pb-3" tabindex="0"
                                        [innerHTML]="question.help_text">
                                    </span>
                                    <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                                        <div *ngIf="form[question.reference].errors.required" role="alert">
                                            {{question.name}}
                                            is
                                            required</div>
                                        <div *ngIf="form[question.reference].errors.pattern" role="alert">
                                            invlaid {{question.name}}</div>
                                    </div>
                                </div>

                                <!-- checkbox -->
                                <div style="margin-bottom: 0px !important;" class="form-group"
                                    *ngIf="question.visible && question.detail_type == 'check' || question.visible && question.detail_type == 'check-price'">
                                    <div class="bb-flex  row-blocks">
                                        <label for="{{question.name}}" style="line-height: 0.8;"><span
                                                *ngIf="question.required" aria-hidden="true"
                                                class="form-field-required-marker">
                                                * </span>
                                            <span *ngIf="question.price == 0">{{question.name}}</span>

                                            <span tabindex="-1" *ngIf="question.price > 0">{{question.name}} -
                                                {{question.price / 100 | currency:'GBP':true}}</span>
                                        </label>
                                    </div>
                                    <div class="bb-flex  row-blocks">
                                        <mat-checkbox formControlName="{{question.reference}}" class="pb-3">
                                        </mat-checkbox>
                                        <span *ngIf="question.help_text">
                                            <br>
                                            <span class="help-text mb-3 pb-3" tabindex="0"
                                                [innerHTML]="question.help_text">
                                            </span>
                                        </span>


                                        <div *ngIf="submitted && form[question.reference].errors?.required" role="alert"
                                            tabindex="0" class="invalid-feedback">
                                            {{question.name}} {{'COMMON.IS_REQUIRED' | translate}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ng-container *ngIf="addressEnabled">
                        <ng-container *ngIf="myAddresses.length === 0">
                            <div class="form-group">
                                <label for="postcode"><span aria-hidden="true" class="form-field-required-marker">
                                        *</span> {{'COMMON.POSTCODE1' | translate}} <span
                                        style="font-weight: bold; text-decoration: underline; ">{{'COMMON.POSTCODE2' |
                                        translate}}</span>{{'COMMON.POSTCODE3' | translate}}</label>
                                <div class="row ml-0 mr-0">
                                    <input (keydown.space)="$event.preventDefault();" id="postcode"
                                        (keydown.spacebar)="$event.preventDefault();" type="text"
                                        class="form-control col-sm-8" formControlName="postcode" role="textbox"
                                        autocomplete="postal-code"
                                        oninput="this.value = this.value.toUpperCase().replaceAll(' ','')">
                                    <button type="button"
                                        class="btn btn-primary col-sm-4 mb-0  govuk-button button-sizer"
                                        [disabled]="!form.postcode.value" (click)="getAddress()">{{'COMMON.FIND_ADDRESS'
                                        |
                                        translate}}</button>
                                </div>
                                <div *ngIf="form.postcode.errors?.addressNotFound" role="alert" tabindex="0"
                                    class="invalid-feedback">
                                    {{form.postcode.errors?.addressNotFound}}</div>
                                <div *ngIf="form.postcode.errors?.invalidPostcode" role="alert" tabindex="0"
                                    class="invalid-feedback">
                                    {{form.postcode.errors?.invalidPostcode}}</div>
                                <div *ngIf="submitted && form.postcode.errors" class="invalid-feedback">
                                    <div *ngIf="form.postcode.errors.required" role="alert" tabindex="0">
                                        Postcode is required</div>
                                </div>
                                <div *ngIf="submitted && form.selectedAddress.errors" class="invalid-feedback">
                                    <div *ngIf="form.selectedAddress.errors.required && !showingAddresses" role="alert"
                                        tabindex="0">
                                        Please click 'FIND ADDRESS'</div>
                                </div>
                            </div>

                            <div class="form-group" *ngIf="addresses.length > 0">
                                <label for="selectedAddress"><span aria-hidden="true"
                                        class="form-field-required-marker">
                                        *</span> {{'COMMON.ADDRESS' | translate}}</label>
                                <select formControlName="selectedAddress" class="form-control"
                                    attr.aria-label="Select address" id="selectedAddress">
                                    <option value="">Please select</option>
                                    <option *ngFor="let item of addresses" [ngValue]="item">
                                        {{item?.address.ADDRESS}}
                                    </option>
                                </select>
                            </div>
                            <div *ngIf="submitted && form.selectedAddress.errors && !form.postcode.errors"
                                class="invalid-feedback">
                                <div *ngIf="form.selectedAddress.errors.required" role="alert" tabindex="0">
                                    An address is required</div>
                            </div>
                            <div *ngIf="this.customerDetailsForm.value.selectedAddress.address">
                                <span *ngIf="!localAddress()" style="font-weight:bolder; color: #c90505;"
                                    class="invalid-feedback">
                                    As this address is not within the Kent administrative area, a £10 per visit
                                    cross-border fee will be applicable when disposing of waste from this address.
                                    Payment on arrival (card payments only).
                                    Please see our <a target="_blank" href="https://kent.gov.uk/hwrccrossborder">cross
                                        border policy</a> for more information.
                                </span>
                            </div>
                            <div *ngFor="let question of customerQuestions;">
                                <!-- postcode question's helptext -->
                                <div *ngIf="question.reference === 382">
                                    <span *ngIf="question.help_text" class="help-text mb-3" tabindex="0"
                                        [innerHTML]="question.help_text">
                                    </span>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="myAddresses.length > 0">
                            <div class="form-group">
                                <label for="selectedAddress"><span aria-hidden="true"
                                        class="form-field-required-marker">
                                        * </span>Select the address where the waste is coming from.</label>
                                <select formControlName="selectedAddress" [value]='-1' class="form-control"
                                    (change)="getPostcode()" attr.aria-label="selectedAddress" id="selectedAddress">

                                    <option></option>
                                    <option *ngFor="let option of myAddresses" [value]="option.address">
                                        {{option.address}}
                                    </option>

                                </select>
                                <div *ngIf="submitted && form.selectedAddress.errors" class="invalid-feedback">
                                    <div *ngIf="form.selectedAddress.errors.required" role="alert" tabindex="0">
                                        An address is required</div>
                                </div>
                                <div *ngIf="this.customerDetailsForm.value.selectedAddress">
                                    <span *ngIf="!idLocalAddress" style="font-weight:bolder; color: #c90505;"
                                        class="invalid-feedback">
                                        As this address is not within the Kent administrative area, a £10 per visit
                                        cross-border fee will be applicable when disposing of waste from this address.
                                        Payment on arrival (card payments only).
                                        Please see our <a target="_blank"
                                            href="https://kent.gov.uk/hwrccrossborder">cross
                                            border policy</a> for more information.
                                    </span>
                                </div>
                                <span class="help-text mb-3" tabindex="0">
                                    If the address is not displayed, please go to 'My account' at the top of the page
                                    where you can add/remove addresses.
                                </span>
                            </div>
                        </ng-container>
                    </ng-container>
                </form>
            </div>

            <div class="card mt-4 bb-panel">
                <form [formGroup]="bookingQuestionsForm" autocomplete="chrome-off"
                    class="col-sm-12 col-md-12 col-lg-12">
                    <h4 class="mt-1 pb-4">{{'COMMON.BOOKING_INFORMATION' | translate}}</h4>
                    <div *ngFor="let question of bookingQuestions;">

                        <div *ngIf="question.visible && question.detail_type == 'heading'">
                            <p>
                                <span *ngIf="question.id === 604">
                                    <b style="color: #c90505;">{{question.name}}</b>
                                </span>
                                <span *ngIf="question.id !== 604">
                                    <b *ngIf="question.id == 453 || question.id == 499">{{question.name}}</b>
                                    <b *ngIf="question.id != 453 && question.id != 499">{{question.name}}</b>
                                </span>

                            </p>
                            <span *ngIf="question.id === 604">
                                <span *ngIf="question.help_text" class="help-text mb-3" tabindex="0"
                                    style="color: #c90505;" [innerHTML]="question.help_text">
                                </span>
                            </span>
                            <span *ngIf="question.id !== 604">
                                <span *ngIf="question.help_text" class="help-text mb-3" tabindex="0"
                                    [innerHTML]="question.help_text">
                                </span>
                            </span>
                        </div>

                        <div class="form-group" *ngIf="question.visible && question.detail_type == 'text_field'">
                            <label for="{{question.name}}"
                                *ngIf="(question.name === 'Vehicle registration' && this.myVehicles.length === 0) || question.name !== 'Vehicle registration'"><span
                                    *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">
                                    *</span> {{question.name}}</label>


                            <ng-container
                                *ngIf="question.name === 'Vehicle make' || question.name === 'Vehicle model' || question.name === 'Vehicle colour' ">
                                <!-- 'Registration number' reference == 4 (Might need changing when merged in if id changes) -->
                                <span *ngIf="vehicleStatus !== 1">
                                    <input maxlength="20" *ngIf="question.reference != 4" type="text"
                                        class="form-control mb-3" formControlName="{{question.reference}}"
                                        attr.aria-label="{{question.name}} input field"
                                        oninput="this.value = this.value.toUpperCase()">
                                    <input maxlength="20" *ngIf="question.reference === 4" type="text"
                                        class="form-control mb-3" formControlName="{{question.reference}}"
                                        attr.aria-label="{{question.name}} input field"
                                        oninput="this.value = this.value.toUpperCase()">
                                </span>
                                <span *ngIf="vehicleStatus === 1">
                                    <input maxlength="20" *ngIf="question.reference != 4" type="text"
                                        class="form-control mb-3" formControlName="{{question.reference}}"
                                        attr.aria-label="{{question.name}} input field"
                                        oninput="this.value = this.value.toUpperCase()" disabled>
                                    <input maxlength="20" *ngIf="question.reference === 4" type="text"
                                        class="form-control mb-3" formControlName="{{question.reference}}"
                                        attr.aria-label="{{question.name}} input field"
                                        oninput="this.value = this.value.toUpperCase()" disabled>
                                </span>

                            </ng-container>
                            <ng-container *ngIf="question.name === 'What type of vehicle will you be arriving in?'">
                                <!-- 'Registration number' reference == 4 (Might need changing when merged in if id changes) -->
                                <span *ngIf="!disableVehicleType">
                                    <input maxlength="20" type="text" class="form-control mb-3"
                                        formControlName="{{question.reference}}"
                                        attr.aria-label="{{question.name}} input field"
                                        oninput="this.value = this.value.toUpperCase()">
                                </span>
                                <span *ngIf="disableVehicleType">
                                    <input maxlength="20" type="text" class="form-control mb-3"
                                        formControlName="{{question.reference}}"
                                        attr.aria-label="{{question.name}} input field"
                                        oninput="this.value = this.value.toUpperCase()" disabled>
                                </span>

                            </ng-container>

                            <ng-container
                                *ngIf="(question.name === 'Vehicle make' || question.name === 'Vehicle model' || question.name === 'Vehicle colour' || question.name === 'Vehicle registration' || question.name === 'What type of vehicle will you be arriving in?') === false">
                                <!-- 'Registration number' reference == 4 (Might need changing when merged in if id changes) -->
                                <input *ngIf="question.reference != 4" type="text" class="form-control mb-3"
                                    formControlName="{{question.reference}}"
                                    attr.aria-label="{{question.name}} input field"
                                    oninput="this.value = this.value.toUpperCase()">
                                <input *ngIf="question.reference === 4" type="text" class="form-control mb-3"
                                    formControlName="{{question.reference}}"
                                    attr.aria-label="{{question.name}} input field"
                                    oninput="this.value = this.value.toUpperCase()">
                            </ng-container>

                            <!--  vehicle lookup -->
                            <ng-container *ngIf="question.name === 'Vehicle registration'">
                                <ng-container *ngIf="this.myVehicles.length === 0">

                                    <div class="form-group">
                                        <div class="row ml-0 mr-0">
                                            <input (keydown.space)="$event.preventDefault();"
                                                (keydown.spacebar)="$event.preventDefault();" type="text"
                                                class="form-control col-sm-8" formControlName="{{question.reference}}"
                                                role="textbox" id="{{question.name}}"
                                                attr.aria-label="{{question.name}}"
                                                oninput="this.value = this.value.replace(/\s/g, '').toUpperCase()">
                                            <button type="button"
                                                class="btn btn-primary col-sm-4 mb-0  govuk-button button-sizer"
                                                [disabled]="!bookingForm[question.reference].valid"
                                                (click)="getVehicle()">Find vehicle</button>
                                        </div>
                                        <span *ngIf="question.help_text" class="help-text mb-3" tabindex="0"
                                            [innerHTML]="question.help_text">
                                        </span>

                                        <span *ngIf="vehicleStatus == 1"
                                            style="color: #36B37E; font-weight: 600;">Vehicle
                                            found. Please
                                            proceed.</span>

                                        <span *ngIf="vehicleStatus == 2" style="color: #c90505; font-weight: 600;">
                                            Vehicle not found, please check your registration. If it's correct, enter
                                            your vehicle make and type below.
                                        </span>

                                        <span *ngIf="vehicleStatus == 3" style="color: #c90505; font-weight: 600;">
                                            Vehicle not found, please check your registration. If it's correct, enter
                                            your vehicle make and type below.
                                        </span>

                                    </div>

                                    <!-- 
                                <input type="text" class="form-control mb-3" formControlName="{{question.reference}}"
                                    attr.aria-label="{{question.name}} input field"
                                    oninput="this.value = this.value.toUpperCase().replace(' ','').substr(0,10)"> -->
                                    <div *ngIf="submitted && bookingForm[question.reference].errors?.required"
                                        role="alert" tabindex="0" class="invalid-feedback">
                                        {{question.name}} {{'COMMON.IS_REQUIRED' | translate}}</div>
                                    <div *ngIf="submitted && vehicleStatus === 0" role="alert" tabindex="0"
                                        class="invalid-feedback">
                                        Please click 'FIND VEHICLE'</div>
                                </ng-container>
                                <ng-container *ngIf="this.myVehicles.length > 0">
                                    <div class="form-group">
                                        <label><span *ngIf="question.required" aria-hidden="true"
                                                class="form-field-required-marker">
                                                * </span>Select your vehicle for this HWRC visit.</label>
                                        <select formControlName="{{question.reference}}" [value]='-1'
                                            class="form-control" (change)="populateStoredVehicleDetails()"
                                            attr.aria-label="{{question.name}}">

                                            <option></option>
                                            <option *ngFor="let option of myVehicles"
                                                [value]="option.vehicle_registration">
                                                {{option.vehicle_registration}}
                                            </option>
                                        </select>
                                        <span class="help-text mb-3" tabindex="0">
                                            If the vehicle is not displayed, please go to 'My account' at the top of the
                                            page where you can add/remove vehicles.
                                        </span>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="question.name !== 'Vehicle registration'">
                                    <ng-container *ngIf="this.myVehicles.length !== 0">
                                        <div *ngIf="submitted && bookingForm[question.reference].errors?.required"
                                            role="alert" tabindex="0" class="invalid-feedback">
                                            {{question.name}} {{'COMMON.IS_REQUIRED' | translate}}</div>
                                    </ng-container>
                                </ng-container>
                            </ng-container>

                            <span
                                *ngIf="question.help_text && question.name !== 'Vehicle colour' && question.name !== 'Vehicle registration'"
                                class="help-text mb-3" tabindex="0" [innerHTML]="question.help_text">
                            </span>
                            <!-- <span *ngIf="question.help_text && question.name === 'Vehicle colour'"
                                class="help-text mb-3" tabindex="0"
                                [innerHTML]="'Please only note the nearest base colour, e.g. silver'">
                            </span> -->
                        </div>

                        <div class="form-group" *ngIf="question.visible && question.detail_type == 'text_area'">
                            <label><span *ngIf="question.required" aria-hidden="true"
                                    class="form-field-required-marker">
                                    *</span> {{question.name}}</label>
                            <textarea class="form-control" formControlName="{{question.reference}}"
                                attr.aria-label="{{question.name}} text area"></textarea>

                            <div *ngIf="submitted && bookingForm[question.reference].errors?.required" role="alert"
                                tabindex="0" class="invalid-feedback">
                                {{question.name}} {{'COMMON.IS_REQUIRED' | translate}}</div>

                            <span *ngIf="question.help_text" class="help-text mb-3" tabindex="0"
                                [innerHTML]="question.help_text">
                            </span>
                        </div>

                        <div class="form-group" *ngIf="question.visible && question.detail_type == 'number'">
                            <label><span *ngIf="question.required" aria-hidden="true"
                                    class="form-field-required-marker">
                                    *</span> {{question.name}}</label>
                            <input type="search" class="form-control" formControlName="{{question.reference}}"
                                attr.aria-label="{{question.name}} input field" maxlength="11"
                                (keypress)="keyPressNumberField($event)">

                            <div *ngIf="submitted && bookingForm[question.reference].errors?.required" role="alert"
                                tabindex="0" class="invalid-feedback">
                                {{question.name}} {{'COMMON.IS_REQUIRED' | translate}}
                            </div>

                            <span *ngIf="question.help_text" class="help-text mb-3" tabindex="0"
                                [innerHTML]="question.help_text">
                            </span>
                        </div>

                        <!-- select dropdown-->
                        <div class="form-group" *ngIf="question.visible && question.detail_type == 'select'">
                            <label><span aria-hidden="true" class="form-field-required-marker"
                                    *ngIf="question.required">
                                    *</span> {{question.name}}</label>
                            <ng-container *ngIf="question.name === 'Vehicle type' && disableVehicleType">
                                <select formControlName="{{question.reference}}" [value]='-1' class="form-control pb-3"
                                    (change)="onQuestionChange()" attr.aria-label="{{question.name}}" disabled>
                                    <option></option>
                                    <option *ngFor="let option of question.options" [value]="option.name">
                                        {{option.name}}
                                    </option>
                                </select>
                            </ng-container>
                            <ng-container *ngIf="question.name !== 'Vehicle type' || !disableVehicleType">
                                <select formControlName="{{question.reference}}" [value]='-1' class="form-control pb-3"
                                    (change)="onQuestionChange()" attr.aria-label="{{question.name}}">
                                    <option></option>
                                    <option *ngFor="let option of question.options" [value]="option.name">
                                        {{option.name}}
                                    </option>
                                </select>
                            </ng-container>

                            <div *ngIf="submitted && bookingForm[question.reference].errors?.required" role="alert"
                                tabindex="0" class="invalid-feedback">
                                {{question.name}} {{'COMMON.IS_REQUIRED' | translate}}</div>

                            <span *ngIf="question.help_text" class="help-text mb-3" tabindex="0"
                                [innerHTML]="question.help_text">
                            </span>
                        </div>

                        <!-- checkbox -->
                        <div class="form-group"
                            *ngIf="question.visible && question.detail_type == 'check' || question.visible && question.detail_type == 'check-price'">
                            <div class="bb-flex  row-blocks">
                                <label for="{{question.reference}}-input"><span *ngIf="question.required"
                                        aria-hidden="true" class="form-field-required-marker">
                                        * </span>
                                    <span *ngIf="question.price == 0">{{question.name}}</span>

                                    <span tabindex="-1" *ngIf="question.price > 0">{{question.name}} -
                                        {{question.price / 100 | currency:'GBP':true}}</span>
                                </label>
                            </div>
                            <div class="bb-flex  row-blocks">
                                <mat-checkbox formControlName="{{question.reference}}" class="pb-3"
                                    id="{{question.reference}}">
                                    <label style="line-height: 0.8;">
                                    </label>
                                </mat-checkbox>
                                <span *ngIf="question.help_text">
                                    <br>
                                    <span class="help-text mb-3 pb-3" tabindex="0" [innerHTML]="question.help_text">
                                    </span>
                                </span>
                            </div>
                        </div>

                        <!-- radio -->
                        <div class="row-blocks pb-3" *ngIf="question.visible && question.detail_type == 'radio'">
                            <label>
                                <span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">*
                                </span> {{question.name}}</label>

                            <mat-radio-group formControlName="{{question.reference}}" class="col-sm-7 radio-group"
                                (change)="onQuestionChange()">
                                <mat-radio-button class="radio-button" *ngFor="let option of question.options"
                                    [value]="option.name">
                                    {{option.name}}
                                </mat-radio-button>
                            </mat-radio-group>

                            <div *ngIf="submitted && bookingForm[question.reference].errors?.required" role="alert"
                                tabindex="0" class="invalid-feedback">
                                {{question.name}} {{'COMMON.IS_REQUIRED' | translate}}
                            </div>
                            <span *ngIf="question.help_text" class="help-text mb-3" tabindex="0"
                                [innerHTML]="question.help_text">
                            </span>
                            <br *ngIf="question.help_text">
                        </div>
                        <!-- br instead of changing css -->
                    </div>
                </form>
            </div>
            <!-- </div>

   

        <div class="col-sm-12 col-md-7 col-lg-8"> -->
            <div class="card mt-4 bb-panel">
                <form [formGroup]="customerDetailsForm" autocomplete="chrome-off" class="col-sm-12">
                    <h4 for="consentCheck" class="mt-1 pb-4">{{'COMMON.DATA_POLICY' | translate}}</h4>
                    <div class="bb-flex row row-blocks" id="tcs">
                        <div class="bb-flex col col-blocks wide">
                            <label for="consentCheck-input" [innerHTML]="dataPolicy"></label>
                        </div>
                    </div>
                    <div class="bb-flex row row-blocks mobile-checkbox-padding" id="tcs">
                        <div class="bb-flex col col-blocks bottom">
                            <mat-checkbox id="consentCheck" class="checkbox privacy-policy"
                                validationForm="consentCheck" formControlName="data_policy">
                                <label for="consentCheck"></label>
                            </mat-checkbox>
                        </div>
                    </div>
                    <div *ngIf="submitted && form.data_policy.errors" class="invalid-feedback">
                        <div *ngIf="form.data_policy.errors.required" role="alert" tabindex="0">
                            Please ensure that you have read and understood our privacy notice and terms of use before
                            proceeding with your booking.
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="col-sm-12 col-md-5 col-lg-4 mt-4">
            <app-booking-summary></app-booking-summary>
        </div>
    </div>



    <div class="row mt-4">
        <div class="col-6">
            <button type="button" class="btn btn-primary govuk-button button-sizer" (click)="routerGoBack()"
                title="Back" aria-label="Back to calendar"><span>
                    <fa-icon [icon]="faChevronLeft"></fa-icon><span>{{'COMMON.BACK' | translate}}</span>
                </span></button>
        </div>
        <div class="col-6">
            <button class="btn btn-primary govuk-button button-sizer float-right" type="button" title="Next"
                aria-label="Next to summary" (click)="onSubmit()"><span><span>{{'COMMON.NEXT'
                        | translate}}</span>
                    <fa-icon [icon]="faChevronRight"></fa-icon>
                </span></button>
        </div>
    </div>
    <br>
</div>

<!-- <div>
        <span>I agree to the details submitted being processed by the re3 partnership for the purpose of managing this
            booking. Please refer to the available re3 <a target="_blank"
                href="https://www.reading.gov.uk/dataprotection"><b>Privacy Notice</b></a>.</span>
        <br><br>
        <span>I confirm that this booking is made for, or on behalf of, a resident of the re3 area and that <b>I
                understand that valid proof of address will be required upon arriving at the recycling
                centre</b>.</span>
    </div> -->